/* eslint-disable no-unused-vars */
export default {
  setShortcuts({ commit }, payload) {
    commit("SET_SHORTCUTS", payload);
  },
};
